import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  name: string;
  url?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="w-full px-4 md:px-6">
      <ol className="flex items-center flex-wrap gap-1 text-sm text-secondary-500 py-3">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          return (
            <li key={index} className="flex items-center gap-1">
              {index > 0 && (
                <span className="text-secondary-400 mx-1">/</span>
              )}
              {item.url && !isLast ? (
                <Link
                  to={item.url}
                  className="hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap"
                >
                  {item.name}
                </Link>
              ) : (
                <span
                  className={`whitespace-nowrap ${isLast ? 'text-foreground-700 font-medium' : ''}`}
                >
                  {item.name}
                </span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}